export const COCM_PATIENT_ID_MAX_LENGTH = 20;

export const resolveCoCMPatientDisplayId = (user) => {
  const id = (user.cocmMeta?.patientId || "").trim();
  if (id) return id;
  return "";
};

export const validateCoCMPatientIdInput = (value) => {
  const trimmed = (value || "").trim();
  if (!trimmed) return { valid: true, value: "" };
  if (trimmed.length > COCM_PATIENT_ID_MAX_LENGTH) {
    return {
      valid: false,
      message: `Patient ID must be ${COCM_PATIENT_ID_MAX_LENGTH} characters or fewer`,
    };
  }
  if (!/^[A-Za-z0-9_-]+$/.test(trimmed)) {
    return {
      valid: false,
      message:
        "Patient ID may only contain letters, numbers, hyphens, and underscores",
    };
  }
  return { valid: true, value: trimmed };
};
